import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/ui';
import { TunnelsCard } from '../settings/PlatformCards';

/**
 * The tunnels' own page at last — WireGuard and OpenVPN state lived as a card
 * buried in Settings while their management hid behind the gateway flow. The
 * card moves here whole; peers themselves are still created and revoked from
 * the Gateways page, and this page says so rather than duplicating it.
 */
export function TunnelsPage() {
  return (
    <>
      <PageHeader
        title="Tunnels"
        description="The management-plane paths to the site routers — WireGuard first, OpenVPN for what cannot run it."
      />
      <div className="space-y-4">
        <TunnelsCard />
        <p className="text-xs text-faint">
          Peers and client certificates are created, rotated and revoked from{' '}
          <Link className="text-primary hover:underline" to="/gateways">
            Gateways
          </Link>{' '}
          — each gateway owns its tunnel end.
        </p>
      </div>
    </>
  );
}
